<template>
  <div>
    <apexchart
      width="100%"
      height="300px"
      :type="options.chart.type"
      :options="options"
      :series="options.series"
    ></apexchart>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      default() {
        return {
          series: [
            {
              name: "sales",
              data: [],
            },
          ],

          xaxis: {
            categories: [],
          },
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
